export default __webpack_public_path__ + "static/media/volunteer.4a436c90.svg";